/* eslint-disable @typescript-eslint/no-explicit-any */
import { Collection, CollectionQuery } from "../../../models/collection.model"
import { Configuration } from "../../../models/configuration.model"
import { Owner } from "../../../models/owner.model"
import { Property } from "../../../models/property.model"
import { Unit } from "../../../models/unit.model"
import { notification } from "../../../shared/component/notification/utility/notification"
import { collectionQueryBuilder } from "../../../shared/utility/collection-builder/collection-query-builder"
import { appApi } from "../../../store/app.api"
import { SETTINGS_ENDPOINT } from "../settings.endpoint"
// import { UNIT_ENDPOINT } from "../unit.endpoint";

let configurationCollection: CollectionQuery
const settingsQuery = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getConfigurations: builder.query<Configuration, CollectionQuery>({
      query: (data: any) => ({
        url: `${SETTINGS_ENDPOINT.detail}`,
        method: "get",
      }),
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            configurationCollection = param
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    updateConfiguration: builder.mutation<Configuration, Configuration>({
      query: (newData: any) => ({
        url: `${SETTINGS_ENDPOINT.update}`,
        method: "put",
        data: newData,
        // permission:'manage-users'
      }),

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated")
            dispatch(
              settingsQuery.util.updateQueryData(
                "getConfigurations",
                configurationCollection,
                (draft) => {
                  if (data) {
                    // draft = data
                    Object.assign(draft, data)
                  }
                },
              ),
            )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    toggleConfidentiality: builder.mutation<Configuration, string>({
      query: (id: string) => ({
        url: `${SETTINGS_ENDPOINT.toggleConfidentiality}/${id}`,
        method: "post",
        // data: newData,
        // permission:'manage-users'
      }),

      invalidatesTags: ["Owner", "Owners"],

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated")

            // dispatch(
            //   settingsQuery.util.updateQueryData(
            //     "getConfigurations",
            //     configurationCollection,
            //     (draft) => {
            //       if (data) {
            //         // draft = data
            //         Object.assign(draft, data)
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
  }),
  overrideExisting: true,
})
export const {
  useLazyGetConfigurationsQuery,
  useUpdateConfigurationMutation,
  useToggleConfidentialityMutation,
} = settingsQuery
